const sortedAlphabetically = (objectValue) => Object.fromEntries(Object.entries(objectValue).sort(([, valueA], [, valueB]) => valueA.localeCompare(valueB)));

export default sortedAlphabetically;
